import { useTranslation } from "react-i18next";

import {
  DateCell,
  DateTimeCell,
  VacancyTableCityCell,
  VacancyTableCountryCell,
  VacancyTableTitleCell,
} from "@/components/ui/v1/table/TableCells";
import { TableColumn } from "@/types/table/tableProps";
import { VacancyType } from "@/types/vacancy/VacancyType";

export const useVacancyTableColumns = () => {
  const { t } = useTranslation();

  const vacancyTableColumns: TableColumn<VacancyType>[] = [
    {
      header: t("common.title"),
      accessor: "title",
      Cell: (row: VacancyType) => <VacancyTableTitleCell vacancy={row} />,
      width: "30%",
    },
    {
      header: t("common.country"),
      accessor: "vacancyLoc.country",
      Cell: (row: VacancyType) => <VacancyTableCountryCell vacancy={row} />,
      width: "15%",
      sortable: true,
    },
    {
      header: t("common.city"),
      accessor: "vacancyLoc.city",
      Cell: (row: VacancyType) => <VacancyTableCityCell vacancy={row} />,
      width: "15%",
      sortable: true,
    },
    {
      header: t("common.publishDate"),
      accessor: "actual",
      Cell: (row: VacancyType): JSX.Element => (
        <DateCell timestamp={row?.actual || ""} />
      ),
      width: "15%",
    },
    {
      header: t("common.lastUpdated"),
      accessor: "updatedDate",
      Cell: (row: VacancyType): JSX.Element => (
        <DateTimeCell timestamp={row?.updatedDate || ""} />
      ),
      width: "20%",
    },
  ];

  return {
    vacancyTableColumns,
  };
};
